import { NameInputChange } from "@screens/Expenses";
import InputSelect from "../Receipt/select";
import { useT } from "@hooks";
import SharedCreateDialog, {
  CategoryTypeTooltip,
  isDuplicatedName,
  useCategoryDialogFields,
} from "../SharedCreateDialog";

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (value: string, selectCategory?: string, selectType?: string) => void;
  title: string;
  placeholder: string;
  name?: string;
  type?: string;
  expenseType?: string;
  showDuplicateAlert?: boolean;
  duplicateAlertMessage?: string;
  existingNames?: string[];
  duplicateNameMessage?: string;
}

const DialogCreateCategorySetttings = ({
  show,
  onClose,
  onSave,
  title,
  placeholder,
  name,
  type,
  expenseType,
  showDuplicateAlert = false,
  duplicateAlertMessage = "",
  existingNames = [],
  duplicateNameMessage = "",
}: Props) => {
  const t = useT();
  const categoryOptions = [
    { id: "DIRETO", label: t("dialog.category.direct") },
    { id: "OPERACIONAL", label: t("dialog.category.operational") },
  ];
  const typeOptions = [
    { id: "DESPESA", label: t("dialog.type.expense") },
    { id: "RECEITA", label: t("dialog.type.recipe") },
  ];

  const {
    error,
    setError,
    errorCategorySelect,
    setErrorCategorySelect,
    errorTypeSelect,
    setErrorTypeSelect,
    valueCategory,
    setValueCategory,
    selectCategory,
    setSelectCategory,
    selectType,
    setSelectType,
    clearErrors,
    clearValues,
  } = useCategoryDialogFields(name, type, expenseType, show);

  const isDuplicateName = isDuplicatedName(valueCategory, existingNames);

  const handleSubmit = () => {
    if (!valueCategory || !selectType) {
      if (!valueCategory) {
        setError(t("common.label.requiredField"));
      }
      if (!selectType) {
        setErrorTypeSelect(t("common.label.requiredField"));
      }
      return;
    }

    if (isDuplicateName) return;

    if (selectType === "DESPESA" && !selectCategory) {
      setErrorCategorySelect(t("common.label.requiredField"));
      return;
    }

    clearErrors();
    clearValues();

    onSave(valueCategory, selectCategory, selectType);
  };

  const handleClose = () => {
    onClose();
    clearValues();
    clearErrors();
  };

  const inputChange = (name: NameInputChange, value?: string) => {
    setSelectCategory(value || "");
  };

  const typeCategoryChange = (name: NameInputChange, value?: string) => {
    if (value === "RECEITA") {
      setSelectCategory("");
    }

    setSelectType(value || "");
  };

  return (
    <SharedCreateDialog
      show={show}
      title={title}
      placeholder={placeholder}
      value={valueCategory}
      onValueChange={setValueCategory}
      error={error}
      isDuplicateName={isDuplicateName}
      duplicateNameMessage={duplicateNameMessage}
      showDuplicateAlert={showDuplicateAlert}
      duplicateAlertMessage={duplicateAlertMessage}
      onClose={handleClose}
      onSubmit={handleSubmit}
      useOverflow={false}
      fieldsAfter={
        <>
          <div className={`form-group ${errorTypeSelect ? "has-feedback has-error" : ""}`}>
            <InputSelect
              inputChange={typeCategoryChange}
              label={t("dialog.category.categoryTypeQuestion")}
              name="category"
              onCreateNewOption={() => {}}
              options={typeOptions}
              value={selectType}
              errorMessage={errorTypeSelect}
            />
          </div>
          {selectType === "DESPESA" ? (
            <div className={`form-group ${errorCategorySelect ? "has-feedback has-error" : ""}`}>
              <InputSelect
                inputChange={inputChange}
                label={t("dialog.category.typeQuestion")}
                name="category"
                onCreateNewOption={() => {}}
                options={categoryOptions}
                value={selectCategory}
                errorMessage={errorCategorySelect}
                tooltip={<CategoryTypeTooltip />}
              />
            </div>
          ) : null}
        </>
      }
    />
  );
};

export default DialogCreateCategorySetttings;
